/** API constants - shared across all features. */

import { getGatewayBaseUrl } from "@/config/gateway";

/** Gateway-owned base URL. Missing configuration fails closed at startup. */
export const API_BASE_URL = getGatewayBaseUrl();
export const API_VERSION = "v1";
export const API_PREFIX = `/api/${API_VERSION}`;

export const REQUEST_TIMEOUT = 30000; // 30 seconds — default page-read / BaseAPIService
/** Fetch + triage + draft pipeline can run many AI calls; avoid false timeouts on Sync now. */
export const INTAKE_SYNC_STEP_TIMEOUT_MS = 180000; // 3 minutes per step
/** Knowledge approve → RAG index and similar Gateway long budgets. Opt-in only. */
export const GATEWAY_LONG_REQUEST_TIMEOUT_MS = 300_000;
export const MAX_RETRIES = 3;
export const RETRY_DELAY = 1000; // 1 second

export const HEADER_REQUEST_ID = "X-Request-Id";
export const HEADER_TRACE_ID = "X-Trace-Id";
export const HEADER_CONTENT_TYPE = "Content-Type";
export const HEADER_ACCEPT = "Accept";
export const HEADER_USER_ID = "X-User-ID";

export const CONTENT_TYPE_JSON = "application/json";
